import React from 'react';
import { addPathToList, Configure_the_message, Expand_message } from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';

//= ========================================================================
const Panel_T06_iMsgExpandTexts = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'imsg_expand_title',
    'imsg_expand_button',
  ];

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      panelHeadline={Expand_message}
      editTextList={addPathToList(editTextList, 'configurations/launch/expand_message/')}
      tooltipsTitles={globJSON.configurations.launch.screens_ordering}
      paragraph={Configure_the_message}
      language={language}
      paragraphMarginBottom={30}
      paddingVertical={25}
      isHollow
    />
  );
};

export default Panel_T06_iMsgExpandTexts;
